// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import React, {useState, useMemo} from 'react';
import cn from 'classnames';
import styles from './icon_selector.module.less';

// Color icons from 24/color folder (47 icons)
import Icon_android_color from '../../oculus/pub/img/icons/24/color/android.svg';
import Icon_androidtv_color
    from '../../oculus/pub/img/icons/24/color/androidtv.svg';
import Icon_appletv_color from '../../oculus/pub/img/icons/24/color/appletv.svg';
import Icon_blog_color from '../../oculus/pub/img/icons/24/color/blog.svg';
import Icon_book_color from '../../oculus/pub/img/icons/24/color/book.svg';
import Icon_cash_app_color
    from '../../oculus/pub/img/icons/24/color/cash_app.svg';
import Icon_check_circle_color
    from '../../oculus/pub/img/icons/24/color/check_circle.svg';
import Icon_chrome_color from '../../oculus/pub/img/icons/24/color/chrome.svg';
import Icon_console_color from '../../oculus/pub/img/icons/24/color/console.svg';
import Icon_dashboard_color
    from '../../oculus/pub/img/icons/24/color/dashboard.svg';
import Icon_dedicated_dc_color
    from '../../oculus/pub/img/icons/24/color/dedicated_dc.svg';
import Icon_edge_color from '../../oculus/pub/img/icons/24/color/edge.svg';
import Icon_events_and_ecommerce_color
    from '../../oculus/pub/img/icons/24/color/events_and_ecommerce.svg';
import Icon_events_resi_color
    from '../../oculus/pub/img/icons/24/color/events_resi.svg';
import Icon_facebook_color
    from '../../oculus/pub/img/icons/24/color/facebook.svg';
import Icon_firefox_color from '../../oculus/pub/img/icons/24/color/firefox.svg';
import Icon_firetv_color from '../../oculus/pub/img/icons/24/color/firetv.svg';
import Icon_free_dc_color from '../../oculus/pub/img/icons/24/color/free_dc.svg';
import Icon_github_color from '../../oculus/pub/img/icons/24/color/github.svg';
import Icon_globe_color from '../../oculus/pub/img/icons/24/color/globe.svg';
import Icon_google_color from '../../oculus/pub/img/icons/24/color/google.svg';
import Icon_huawei_store_color
    from '../../oculus/pub/img/icons/24/color/huawei_store.svg';
import Icon_huawei_color from '../../oculus/pub/img/icons/24/color/huawei.svg';
import Icon_ie_color from '../../oculus/pub/img/icons/24/color/ie.svg';
import Icon_ios_color from '../../oculus/pub/img/icons/24/color/ios.svg';
import Icon_isp_premium_color
    from '../../oculus/pub/img/icons/24/color/isp_premium.svg';
import Icon_isp_color from '../../oculus/pub/img/icons/24/color/isp.svg';
import Icon_lg_store_color
    from '../../oculus/pub/img/icons/24/color/lg_store.svg';
import Icon_lg_color from '../../oculus/pub/img/icons/24/color/lg.svg';
import Icon_lightning_color
    from '../../oculus/pub/img/icons/24/color/lightning.svg';
import Icon_linkedin_color
    from '../../oculus/pub/img/icons/24/color/linkedin.svg';
import Icon_macos_color from '../../oculus/pub/img/icons/24/color/macos.svg';
import Icon_opera_color from '../../oculus/pub/img/icons/24/color/opera.svg';
import Icon_playstation_color
    from '../../oculus/pub/img/icons/24/color/playstation.svg';
import Icon_play_store_color
    from '../../oculus/pub/img/icons/24/color/play_store.svg';
import Icon_puzzle_color from '../../oculus/pub/img/icons/24/color/puzzle.svg';
import Icon_residential_color
    from '../../oculus/pub/img/icons/24/color/residential.svg';
import Icon_router_color from '../../oculus/pub/img/icons/24/color/router.svg';
// XXX dmitriikup: URG request from noav to remove all Samsung
// mentions from www
// import Icon_samsung_store_color
//     from '../../oculus/pub/img/icons/24/color/samsung_store.svg';
// import Icon_samsung_color from '../../oculus/pub/img/icons/24/color/samsung.svg';
import Icon_shared_dc_color
    from '../../oculus/pub/img/icons/24/color/shared_dc.svg';
import Icon_smarttv_color from '../../oculus/pub/img/icons/24/color/smarttv.svg';
import Icon_sneakers_color
    from '../../oculus/pub/img/icons/24/color/sneakers.svg';
import Icon_stopwatch_color
    from '../../oculus/pub/img/icons/24/color/stopwatch.svg';
import Icon_use_cases_color
    from '../../oculus/pub/img/icons/24/color/use-cases.svg';
import Icon_windows_color from '../../oculus/pub/img/icons/24/color/windows.svg';
import Icon_xbox_color from '../../oculus/pub/img/icons/24/color/xbox.svg';

// Base icons from 24/ folder (unique ones not in color/)
import Icon_account from '../../oculus/pub/img/icons/24/account.svg';
import Icon_add from '../../oculus/pub/img/icons/24/add.svg';
import Icon_ads from '../../oculus/pub/img/icons/24/ads.svg';
import Icon_ai from '../../oculus/pub/img/icons/24/ai.svg';
import Icon_anti_fraud from '../../oculus/pub/img/icons/24/anti_fraud.svg';
import Icon_arrow_down from '../../oculus/pub/img/icons/24/arrow_down.svg';
import Icon_arrow_left from '../../oculus/pub/img/icons/24/arrow_left.svg';
import Icon_arrow_left_down
    from '../../oculus/pub/img/icons/24/arrow_left_down.svg';
import Icon_arrow_left_up from '../../oculus/pub/img/icons/24/arrow_left_up.svg';
import Icon_arrow_right from '../../oculus/pub/img/icons/24/arrow_right.svg';
import Icon_arrow_right_down
    from '../../oculus/pub/img/icons/24/arrow_right_down.svg';
import Icon_arrow_right_up
    from '../../oculus/pub/img/icons/24/arrow_right_up.svg';
import Icon_arrow_up from '../../oculus/pub/img/icons/24/arrow_up.svg';
import Icon_attachment from '../../oculus/pub/img/icons/24/attachment.svg';
import Icon_bandwidth from '../../oculus/pub/img/icons/24/bandwidth.svg';
import Icon_bank_card from '../../oculus/pub/img/icons/24/bank_card.svg';
import Icon_bank_card_crossed
    from '../../oculus/pub/img/icons/24/bank_card_crossed.svg';
import Icon_brand from '../../oculus/pub/img/icons/24/brand.svg';
import Icon_calendar_important
    from '../../oculus/pub/img/icons/24/calendar_important.svg';
import Icon_chat_line from '../../oculus/pub/img/icons/24/chat-line.svg';
import Icon_checkbox_multiple
    from '../../oculus/pub/img/icons/24/checkbox_multiple.svg';
import Icon_check_line from '../../oculus/pub/img/icons/24/check_line.svg';
import Icon_chevron_down from '../../oculus/pub/img/icons/24/chevron_down.svg';
import Icon_chevron_down_small
    from '../../oculus/pub/img/icons/24/chevron_down_small.svg';
import Icon_chevron_left from '../../oculus/pub/img/icons/24/chevron_left.svg';
import Icon_chevron_left_small
    from '../../oculus/pub/img/icons/24/chevron_left_small.svg';
import Icon_chevron_right from '../../oculus/pub/img/icons/24/chevron_right.svg';
import Icon_chevron_right_small
    from '../../oculus/pub/img/icons/24/chevron_right_small.svg';
import Icon_chevron_up from '../../oculus/pub/img/icons/24/chevron_up.svg';
import Icon_chevron_up_small
    from '../../oculus/pub/img/icons/24/chevron_up_small.svg';
import Icon_close from '../../oculus/pub/img/icons/24/close.svg';
import Icon_content from '../../oculus/pub/img/icons/24/content.svg';
import Icon_copy from '../../oculus/pub/img/icons/24/copy.svg';
import Icon_damaged_file from '../../oculus/pub/img/icons/24/damaged_file.svg';
import Icon_dashboard_notification
    from '../../oculus/pub/img/icons/24/dashboard_notification.svg';
import Icon_data from '../../oculus/pub/img/icons/24/data.svg';
import Icon_download from '../../oculus/pub/img/icons/24/download.svg';
import Icon_email from '../../oculus/pub/img/icons/24/email.svg';
import Icon_events from '../../oculus/pub/img/icons/24/events.svg';
import Icon_eye from '../../oculus/pub/img/icons/24/eye.svg';
import Icon_eye_crossed from '../../oculus/pub/img/icons/24/eye_crossed.svg';
import Icon_file from '../../oculus/pub/img/icons/24/file.svg';
import Icon_flag from '../../oculus/pub/img/icons/24/flag.svg';
import Icon_heart from '../../oculus/pub/img/icons/24/heart.svg';
import Icon_heart_filled from '../../oculus/pub/img/icons/24/heart_filled.svg';
import Icon_help from '../../oculus/pub/img/icons/24/help.svg';
import Icon_lead from '../../oculus/pub/img/icons/24/lead.svg';
import Icon_market from '../../oculus/pub/img/icons/24/market.svg';
import Icon_menu from '../../oculus/pub/img/icons/24/menu.svg';
import Icon_more from '../../oculus/pub/img/icons/24/more.svg';
import Icon_notification from '../../oculus/pub/img/icons/24/notification.svg';
import Icon_plus from '../../oculus/pub/img/icons/24/plus.svg';
import Icon_price from '../../oculus/pub/img/icons/24/price.svg';
import Icon_product from '../../oculus/pub/img/icons/24/product.svg';
import Icon_receipt from '../../oculus/pub/img/icons/24/receipt.svg';
import Icon_refresh from '../../oculus/pub/img/icons/24/refresh.svg';
import Icon_renewal from '../../oculus/pub/img/icons/24/renewal.svg';
import Icon_renewal_crossed
    from '../../oculus/pub/img/icons/24/renewal_crossed.svg';
import Icon_retail from '../../oculus/pub/img/icons/24/retail.svg';
import Icon_search_fill from '../../oculus/pub/img/icons/24/search_fill.svg';
import Icon_search_line from '../../oculus/pub/img/icons/24/search_line.svg';
import Icon_sentiment from '../../oculus/pub/img/icons/24/sentiment.svg';
import Icon_seo from '../../oculus/pub/img/icons/24/seo.svg';
import Icon_slash from '../../oculus/pub/img/icons/24/slash.svg';
import Icon_social_media from '../../oculus/pub/img/icons/24/social_media.svg';
import Icon_state_empty from '../../oculus/pub/img/icons/24/state_empty.svg';
import Icon_state_empty_small
    from '../../oculus/pub/img/icons/24/state_empty_small.svg';
import Icon_state_filled from '../../oculus/pub/img/icons/24/state_filled.svg';
import Icon_state_filled_small
    from '../../oculus/pub/img/icons/24/state_filled_small.svg';
import Icon_state_half from '../../oculus/pub/img/icons/24/state_half.svg';
import Icon_state_half_small
    from '../../oculus/pub/img/icons/24/state_half_small.svg';
import Icon_subtract from '../../oculus/pub/img/icons/24/subtract.svg';
import Icon_support_fill from '../../oculus/pub/img/icons/24/support_fill.svg';
import Icon_time from '../../oculus/pub/img/icons/24/time.svg';
import Icon_trash from '../../oculus/pub/img/icons/24/trash.svg';
import Icon_travel from '../../oculus/pub/img/icons/24/travel.svg';
import Icon_triangle_down from '../../oculus/pub/img/icons/24/triangle_down.svg';
import Icon_triangle_left from '../../oculus/pub/img/icons/24/triangle_left.svg';
import Icon_triangle_right
    from '../../oculus/pub/img/icons/24/triangle_right.svg';
import Icon_triangle_up from '../../oculus/pub/img/icons/24/triangle_up.svg';
import Icon_upload from '../../oculus/pub/img/icons/24/upload.svg';
import Icon_warning from '../../oculus/pub/img/icons/24/warning.svg';
import Icon_warning_line from '../../oculus/pub/img/icons/24/warning-line.svg';
import Icon_warning_triangle
    from '../../oculus/pub/img/icons/24/warning_triangle.svg';

// Additional icons from parent icons folder
import Icon_gear from '../../oculus/pub/img/icons/gear.svg';
import Icon_discord from '../../oculus/pub/img/icons/discord.svg';

// Toolip icons from 24/ folder
import Toolip_approved from '../../toolip/pub/img/icons/24/approved.svg';
import Toolip_anonymity from '../../toolip/pub/img/icons/24/anonymity.svg';
import Toolip_bandwidth from '../../toolip/pub/img/icons/24/bandwidth.svg';
import Toolip_buildings from '../../toolip/pub/img/icons/24/buildings.svg';
import Toolip_bypass from '../../toolip/pub/img/icons/24/bypass.svg';
import Toolip_chart_pie from '../../toolip/pub/img/icons/24/chart_pie.svg';
import Toolip_effective from '../../toolip/pub/img/icons/24/effective.svg';
import Toolip_flexible_usage from '../../toolip/pub/img/icons/24/flexible_usage.svg';
import Toolip_gift from '../../toolip/pub/img/icons/24/gift.svg';
import Toolip_hello from '../../toolip/pub/img/icons/24/hello.svg';
import Toolip_laptop from '../../toolip/pub/img/icons/24/laptop.svg';
import Toolip_location from '../../toolip/pub/img/icons/24/location.svg';
import Toolip_notify from '../../toolip/pub/img/icons/24/notification.svg';
import Toolip_profile from '../../toolip/pub/img/icons/24/profile.svg';
import Toolip_protect from '../../toolip/pub/img/icons/24/protect.svg';
import Toolip_resource from '../../toolip/pub/img/icons/24/resource.svg';
import Toolip_seamless from '../../toolip/pub/img/icons/24/seamless.svg';
import Toolip_shield from '../../toolip/pub/img/icons/24/shield.svg';
import Toolip_slider02 from '../../toolip/pub/img/icons/24/slider02.svg';
import Toolip_speed from '../../toolip/pub/img/icons/24/speed.svg';
import Toolip_users from '../../toolip/pub/img/icons/24/users.svg';
import Toolip_world from '../../toolip/pub/img/icons/24/world.svg';

type t_icon_component = React.FC<React.SVGProps<SVGSVGElement>>;

// Map of icon names to components - exported for use in other components
export const icon_components: Record<string, t_icon_component> = {
    // Color icons (prefixed for distinction)
    'android-color': Icon_android_color,
    'androidtv-color': Icon_androidtv_color,
    'appletv-color': Icon_appletv_color,
    'blog-color': Icon_blog_color,
    'book': Icon_book_color,
    'cash_app-color': Icon_cash_app_color,
    'check_circle': Icon_check_circle_color,
    'chrome-color': Icon_chrome_color,
    'console': Icon_console_color,
    'dashboard-color': Icon_dashboard_color,
    'dedicated_dc': Icon_dedicated_dc_color,
    'edge-color': Icon_edge_color,
    'events_and_ecommerce': Icon_events_and_ecommerce_color,
    'events_resi': Icon_events_resi_color,
    'facebook-color': Icon_facebook_color,
    'firefox-color': Icon_firefox_color,
    'firetv-color': Icon_firetv_color,
    'free_dc': Icon_free_dc_color,
    'github-color': Icon_github_color,
    'globe': Icon_globe_color,
    'google-color': Icon_google_color,
    'huawei_store-color': Icon_huawei_store_color,
    'huawei-color': Icon_huawei_color,
    'ie-color': Icon_ie_color,
    'ios-color': Icon_ios_color,
    'isp_premium': Icon_isp_premium_color,
    'isp': Icon_isp_color,
    'lg_store-color': Icon_lg_store_color,
    'lg-color': Icon_lg_color,
    'lightning': Icon_lightning_color,
    'linkedin-color': Icon_linkedin_color,
    'macos-color': Icon_macos_color,
    'opera-color': Icon_opera_color,
    'playstation-color': Icon_playstation_color,
    'play_store-color': Icon_play_store_color,
    'puzzle': Icon_puzzle_color,
    'residential': Icon_residential_color,
    'router': Icon_router_color,
    // XXX dmitriikup: URG request from noav to remove all Samsung
    // mentions from www
    // 'samsung_store-color': Icon_samsung_store_color,
    // 'samsung-color': Icon_samsung_color,
    'shared_dc': Icon_shared_dc_color,
    'smarttv-color': Icon_smarttv_color,
    'sneakers': Icon_sneakers_color,
    'stopwatch': Icon_stopwatch_color,
    'use-cases': Icon_use_cases_color,
    'windows-color': Icon_windows_color,
    'xbox-color': Icon_xbox_color,
    // Base icons
    account: Icon_account,
    add: Icon_add,
    ads: Icon_ads,
    ai: Icon_ai,
    anti_fraud: Icon_anti_fraud,
    arrow_down: Icon_arrow_down,
    arrow_left: Icon_arrow_left,
    arrow_left_down: Icon_arrow_left_down,
    arrow_left_up: Icon_arrow_left_up,
    arrow_right: Icon_arrow_right,
    arrow_right_down: Icon_arrow_right_down,
    arrow_right_up: Icon_arrow_right_up,
    arrow_up: Icon_arrow_up,
    attachment: Icon_attachment,
    bandwidth: Icon_bandwidth,
    bank_card: Icon_bank_card,
    bank_card_crossed: Icon_bank_card_crossed,
    brand: Icon_brand,
    calendar_important: Icon_calendar_important,
    'chat-line': Icon_chat_line,
    checkbox_multiple: Icon_checkbox_multiple,
    check_line: Icon_check_line,
    chevron_down: Icon_chevron_down,
    chevron_down_small: Icon_chevron_down_small,
    chevron_left: Icon_chevron_left,
    chevron_left_small: Icon_chevron_left_small,
    chevron_right: Icon_chevron_right,
    chevron_right_small: Icon_chevron_right_small,
    chevron_up: Icon_chevron_up,
    chevron_up_small: Icon_chevron_up_small,
    close: Icon_close,
    content: Icon_content,
    copy: Icon_copy,
    damaged_file: Icon_damaged_file,
    dashboard_notification: Icon_dashboard_notification,
    data: Icon_data,
    download: Icon_download,
    email: Icon_email,
    events: Icon_events,
    eye: Icon_eye,
    eye_crossed: Icon_eye_crossed,
    file: Icon_file,
    flag: Icon_flag,
    heart: Icon_heart,
    heart_filled: Icon_heart_filled,
    help: Icon_help,
    lead: Icon_lead,
    market: Icon_market,
    menu: Icon_menu,
    more: Icon_more,
    notification: Icon_notification,
    plus: Icon_plus,
    price: Icon_price,
    product: Icon_product,
    receipt: Icon_receipt,
    refresh: Icon_refresh,
    renewal: Icon_renewal,
    renewal_crossed: Icon_renewal_crossed,
    retail: Icon_retail,
    search_fill: Icon_search_fill,
    search_line: Icon_search_line,
    sentiment: Icon_sentiment,
    seo: Icon_seo,
    slash: Icon_slash,
    social_media: Icon_social_media,
    state_empty: Icon_state_empty,
    state_empty_small: Icon_state_empty_small,
    state_filled: Icon_state_filled,
    state_filled_small: Icon_state_filled_small,
    state_half: Icon_state_half,
    state_half_small: Icon_state_half_small,
    subtract: Icon_subtract,
    support_fill: Icon_support_fill,
    time: Icon_time,
    trash: Icon_trash,
    travel: Icon_travel,
    triangle_down: Icon_triangle_down,
    triangle_left: Icon_triangle_left,
    triangle_right: Icon_triangle_right,
    triangle_up: Icon_triangle_up,
    upload: Icon_upload,
    warning: Icon_warning,
    'warning-line': Icon_warning_line,
    warning_triangle: Icon_warning_triangle,
    // Additional icons
    gear: Icon_gear,
    discord: Icon_discord,
    // Toolip icons (prefixed with 'toolip_')
    'toolip_approved': Toolip_approved,
    'toolip_anonymity': Toolip_anonymity,
    'toolip_bandwidth': Toolip_bandwidth,
    'toolip_buildings': Toolip_buildings,
    'toolip_bypass': Toolip_bypass,
    'toolip_chart_pie': Toolip_chart_pie,
    'toolip_effective': Toolip_effective,
    'toolip_flexible_usage': Toolip_flexible_usage,
    'toolip_gift': Toolip_gift,
    'toolip_hello': Toolip_hello,
    'toolip_laptop': Toolip_laptop,
    'toolip_location': Toolip_location,
    'toolip_notify': Toolip_notify,
    'toolip_profile': Toolip_profile,
    'toolip_protect': Toolip_protect,
    'toolip_resource': Toolip_resource,
    'toolip_seamless': Toolip_seamless,
    'toolip_shield': Toolip_shield,
    'toolip_slider02': Toolip_slider02,
    'toolip_speed': Toolip_speed,
    'toolip_users': Toolip_users,
    'toolip_world': Toolip_world,
};

export const icon_names = Object.keys(icon_components);

interface i_icon_selector_props {
    value: string;
    on_change: (icon: string)=>void;
}

export const Icon_selector = (props: i_icon_selector_props)=>{
    const {value, on_change} = props;
    const [is_open, set_is_open] = useState(false);
    const [search, set_search] = useState('');
    type t_icon_source = 'oculus' | 'toolip';
    const [icon_source, set_icon_source] =
        useState<t_icon_source>('oculus');
    const filtered_icons = useMemo(()=>{
        let icons = icon_names.filter(icon=>
            icon_source === 'toolip' ? icon.startsWith('toolip_')
                : !icon.startsWith('toolip_'));
        if (!search)
            return icons;
        const lower = search.toLowerCase();
        return icons.filter(icon=>icon.toLowerCase().includes(lower));
    }, [search, icon_source]);
    const handle_select = (icon: string)=>{
        on_change(icon);
        set_is_open(false);
        set_search('');
    };
    const Current_icon = value ? icon_components[value] : null;
    const render_icon_btn = (icon: string)=>{
        const Icon = icon_components[icon];
        return <button key={icon} type="button" title={icon}
          className={cn(styles.icon_item, value === icon && styles.selected)}
          onClick={()=>handle_select(icon)}>
          <Icon className={styles.grid_icon} />
          <span className={styles.icon_label}>{icon}</span>
        </button>;
    };
    return <div className={styles.icon_selector}>
      <button type="button" className={styles.trigger}
        onClick={()=>set_is_open(!is_open)}>
        {Current_icon
            ? <Current_icon className={styles.preview_icon} />
            : <span className={styles.empty} />}
        <span className={styles.icon_name}>{value || 'Select icon'}</span>
        <span className={styles.chevron}>{'\u25BC'}</span>
      </button>
      {is_open && <div className={styles.dropdown_wrapper}>
        <div className={styles.backdrop} onClick={()=>set_is_open(false)} />
        <div className={styles.dropdown}>
          <div className={styles.search_container}>
            <input type="text" placeholder="Search icons..." value={search}
              onChange={e=>set_search(e.target.value)}
              className={styles.search_input} autoFocus />
            <div className={styles.source_selector}>
              <button type="button"
                className={cn(styles.source_btn,
                  icon_source === 'oculus' && styles.active)}
                onClick={()=>set_icon_source('oculus')}>Oculus</button>
              <button type="button"
                className={cn(styles.source_btn,
                  icon_source === 'toolip' && styles.active)}
                onClick={()=>set_icon_source('toolip')}>Toolip</button>
            </div>
          </div>
          <div className={styles.icons_grid}>
            {filtered_icons.map(render_icon_btn)}
            {filtered_icons.length === 0 &&
              <div className={styles.no_results}>No icons found</div>}
          </div>
        </div>
      </div>}
    </div>;
};
